









import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync, Watch } from 'vue-property-decorator';

import ScorebatService from '@/services/ScorebatService';
import LeagueBoardHeader from '@/components/LeagueBoard/LeagueBoardHeader.vue';
import LeagueLeaderBoard from '@/components/LeagueBoard/LeagueLeaderBoard.vue';

@Component({
    components: {
        LeagueBoardHeader,
        LeagueLeaderBoard,
    }
})
export default class LeagueBoard extends Vue {
    public boardData: any = {};


    public leagueInfos = {};
    public leaderboard = {};

    created() {
        this.initLeaderboard();
    }

    // The watch here help to refresh whenever the route param is changing
    @Watch('$route.params.leagueId')
    initLeaderboard() {
        ScorebatService.getBoardInfo(this.$route.params.leagueId).then((response) => {
            this.boardData = response.data;

            this.leagueInfos = {
                name: response.data.response.name,
                flag: response.data.response.flag
            };

            this.leaderboard = response.data.response.standings;
        });
    }
}
